// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { FormFieldClickable } from "@insite/mobius/FormField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        padding-top: 14px;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        weight: fontConfig.weight.bold,
        color: "common.ui4",
        css: css`
            line-height: 13px;
        `,
    },
    css: css`
        ${TypographyStyle} {
            ${({ isSignInOverlay }: any) =>
                isSignInOverlay
                    ? css`
                          font-size: 10px;
                          line-height: 11px;
                      `
                    : css`
                          font-size: 12px;
                          line-height: 13px;
                      `}
        }
    `,
};
signInExistingAccountStyles.form = {
    css: css`
        max-width: 450px;
    `,
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalBody: css`
            &&& {
                max-width: 450px;
            }
        `,
    },
};

signInExistingAccountStyles.signInGridContainer = {
    gap: 12,
};

signInExistingAccountStyles.icon = {
    css: css`
        padding-top: 50px;
        &&& {
            width: 37px;
        }
    `,
};

signInExistingAccountStyles.passwordTextField = {
    cssOverrides: {
        formInputWrapper: css`
            ${FormFieldClickable} {
                &:not(:disabled):hover {
                    & > span {
                        color: ${color("common.ui9")};
                    }
                }
            }
        `,
    },
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h3",
    as: "h3",
    css: css`
        margin-bottom: 12px;
    `,
};

signInExistingAccountStyles.signInButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: auto;
        }
    `,
};
